<!--单位信息模块-->
<template>
  <div class="unitInfoBody">
    <div class="topLeftTitleContent">基本信息</div>
    <div class="unitContent bodyBorder">
      <columnsContent class="columnsContent" img="unitInfo_1" columns="地址" :content="nowUnit.address"></columnsContent>
      <columnsContent class="columnsContent" img="unitInfo_2" columns="联系人" :content="nowUnit.phoneNum">
      </columnsContent>
      <columnsContent class="columnsContent" img="unitInfo_3" columns="接入时间"
        :content="new Date(nowUnit.joinTime).formatByTime('-')"></columnsContent>

      <columnsContent class="columnsContent toExport" img="unitInfo_4" columns="运维报告" content="点击导出上月运维报告"
        @onClick="exportReport" v-if="showExport"></columnsContent>
    </div>
  </div>
</template>

<script>
  import columnsContent from '@/page/unitProfile/columnsContent.vue'
  export default {
    components: {
      columnsContent,
    },
    props: [],
    data () {
      return {
      }
    },
    created () {},
    mounted () {
    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      showExport () {
        //看看是不是应该显示导出运维报告
        return this.$router.currentRoute.path!='/temperatureOverView'
      }
    },
    watch: {

    },
    methods: {
      exportReport () {
        this.$dialogMethod.showLoading("正在生成报告。。。")
        this.$api.reportApi.exportUnitMonthReportWord(this.nowUnit.id,new Date(new Date().formatByMonth()).getTime()-24*
          60*
          60*1000,respon => {
            if(!respon.includes('%2F')) {
              this.$dialogMethod.showMessage(respon)
              return
            }
            saveAs(DWSystemSetting.downloadUrl+'/'+respon,respon.substring(respon.lastIndexOf('%2F')+3))
            this.$dialogMethod.closeLoading()
          })
      },
    }
  }
</script>

<style scoped>
  @import url("../../components/css/usePowerUnit.css");

  .unitInfoBody {
    height: 274px;
  }

  .columnsContent {
    margin: 20px 10px;
  }

  .unitContent {
    height: calc(100% - 31px);
    overflow: hidden;
  }
</style>